import React, { useEffect, useState } from "react";
import "./Evenements.scss";
import Footer from "Components/Footer/Footer";
import Header from "Components/Header/Header";
import ButtonsBarDisconnected from "Components/Header/ButtonsBarDisconnected/ButtonsBarDisconnected";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import EvenementsContainer from "Components/Evenements/EvenementsContainer/EvenementsContainer";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import EvenementsCreation from "Components/Evenements/EvenementsCreation/EvenementsCreation";
import EvenementsManagement from "Components/Evenements/EvenementsManagement/EvenementsManagement";
import { updateEvents } from "Redux/Actions/eventsActions";
import axios from "axios";

/**
 * Permet d'afficher la page des événements
 * Avant connexion et après connexion pour les étudiants sont similaire
 * Les alumni et personnels peuvent proposer des événements et les gérer, les admins peuvent les créer et les gérer
 */
// TO DO : gestion éditoriale : intégrer la modification de titre des événements
const Evenements = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [activeIndex, setActiveIndex] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [activeIndexAdmin, setActiveIndexAdmin] = useState(0);

  useEffect(() => {
    if (props.auth.userConnected != null) {
      axios
        .get(
          `${process.env.REACT_APP_BASE_URL_API}/user_events/${props.auth.userConnected.id}`,
          {
            headers: props.auth.token
              ? {
                  accept: "application/json",
                  Authorization: `Bearer ${props.auth.token}`,
                }
              : {
                  accept: "application/json",
                },
          }
        )
        .then((response) => {
          props.handleUpdateEvents({ myEvents: response.data });
        })
        .catch((error) => console.log(error));
    }
  }, []);
  // remplissage de Redux avec les données des événements
  useEffect(() => {
    if (props.states.statesData.length > 0) {
      const dataEventStatusModified = props.states.statesData.map((state) => {
        return {
          id: state.id,
          name: state.statusLabel,
          statusLabel: state.statusLabel,
        };
      });
      const listOfStatus = [
        "Brouillon",
        "Refusé",
        "En Attente",
        "Publié",
        "Cloturé",
      ];

      props.handleUpdateEvents({
        etats: dataEventStatusModified.filter(
          (state) => listOfStatus.indexOf(state.name) !== -1
        ),
      });
    }
  }, [props.states.statesData.length]);

  return (
    <div>
      {/* affichage du header si connecté  */}
      {props.auth.isConnected ? (
        <>
          {(() => {
            switch (true) {
              case props.auth.isAdmin:
                return (
                  <Header noImage={false}>
                    <NavBarTab
                      select="evenementadmin"
                      activeIndex={props.items.activeItemEvenementAdmin}
                      items={props.items.itemsEvenementAdmin}
                    />
                  </Header>
                );
              case props.auth.userConnected.userRoles.some(
                (role) => role.roleName == "ROLE_ETUDIANT"
              ):
                return <Header noImage={true} />;
              case props.auth.userConnected.userRoles.some(
                (role) =>
                  role.roleName == "ROLE_ALUMNI" ||
                  role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
              ):
                return (
                  <Header noImage={false}>
                    <NavBarTab
                      select="evenement"
                      activeIndex={props.items.activeItemEvenement}
                      items={props.items.itemsEvenement}
                    />
                  </Header>
                );
              default:
                return <Header noImage={true} />;
            }
          })()}
        </>
      ) : (
        // Si non connecté :
        <>
          {
            <Header noImage={true}>
              <ButtonsBarDisconnected />
            </Header>
          }
        </>
      )}
      {/* affichage du reste de la page  */}
      {/* Si non connecté : */}
      {!props.auth.isConnected ? (
        <>{<EvenementsContainer />}</>
      ) : (
        // Si connecté :
        <>
          {(() => {
            switch (true) {
              case props.auth.isAdmin &&
                props.items.activeItemEvenementAdmin ==
                  props.items.itemsEvenementAdmin.findIndex(
                    (i) => i.label == "Tous les événements"
                  ):
                return <EvenementsContainer />;
              case props.auth.userConnected.userRoles.some(
                (role) => role.roleName == "ROLE_ETUDIANT"
              ):
                return <EvenementsContainer />;
              case props.auth.userConnected.userRoles.some(
                (role) =>
                  role.roleName == "ROLE_ALUMNI" ||
                  role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
              ) &&
                props.items.activeItemEvenement ==
                  props.items.itemsEvenement.findIndex(
                    (i) => i.label == "Tous les événements"
                  ):
                return <EvenementsContainer />;
              default:
                return null;
            }
          })()}
          {/* création d'événements  */}
          {(() => {
            switch (true) {
              case props.auth.isAdmin &&
                props.items.activeItemEvenementAdmin ==
                  props.items.itemsEvenementAdmin.findIndex(
                    (itemIndex) => itemIndex.label == "Créer un événement"
                  ):
                return (
                  <EvenementsCreation
                    activeIndex={props.items.itemsEvenementAdmin.findIndex(
                      (itemIndex) => itemIndex.label == "Créer un événement"
                    )}
                    setActiveIndex={setActiveIndexAdmin}
                    items={props.items.itemsEvenementAdmin}
                  />
                );
              case props.auth.userConnected.userRoles.some(
                (role) =>
                  role.roleName == "ROLE_ALUMNI" ||
                  role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
              ) &&
                props.items.activeItemEvenement ==
                  props.items.itemsEvenement.findIndex(
                    (itemIndex) => itemIndex.label == "Proposer un événement"
                  ):
                return (
                  <EvenementsCreation
                    activeIndex={props.items.itemsEvenement.findIndex(
                      (itemIndex) => itemIndex.label == "Proposer un événement"
                    )}
                    setActiveIndex={setActiveIndex}
                    items={props.items.itemsEvenement}
                  />
                );
              default:
                return null;
            }
          })()}
          {/* gestion d'événements  */}
          {(() => {
            switch (true) {
              case props.auth.isAdmin &&
                props.items.activeItemEvenementAdmin ==
                  props.items.itemsEvenementAdmin.findIndex(
                    (itemIndex) => itemIndex.label == "Gérer les événements"
                  ):
                return (
                  <EvenementsManagement
                    activeIndex={props.items.itemsEvenementAdmin.findIndex(
                      (itemIndex) => itemIndex.label == "Gérer les événements"
                    )}
                    setActiveIndex={setActiveIndexAdmin}
                    items={props.items.itemsEvenementAdmin}
                  />
                );
              case props.auth.userConnected.userRoles.some(
                (role) =>
                  role.roleName == "ROLE_ALUMNI" ||
                  role.roleName == "ROLE_PERSONNEL_UNIVERSITE"
              ) &&
                props.items.activeItemEvenement ==
                  props.items.itemsEvenement.findIndex(
                    (itemIndex) => itemIndex.label == "Gérer mes événements"
                  ):
                return (
                  <EvenementsManagement
                    activeIndex={props.items.itemsEvenement.findIndex(
                      (itemIndex) => itemIndex.label == "Gérer mes événements"
                    )}
                    setActiveIndex={setActiveIndex}
                    items={props.items.itemsEvenement}
                  />
                );
              default:
                return null;
            }
          })()}
        </>
      )}

      <Footer />
    </div>
  );
};

Evenements.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
  handleUpdateEvents: PropTypes.func,
  events: PropTypes.object,
  states: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  events: state.events,
  states: state.states,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateEvents: (value) => {
    dispatch(updateEvents(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Evenements);
